import React, { useState, useEffect, useContext, useRef } from 'react'
import './OfertaBanner.css'
import { IoPersonAddSharp } from "react-icons/io5";
import { useNavigate } from 'react-router';
import { GiClick } from "react-icons/gi";
import { FaCheck } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import { globalContext } from '../Context/GlobalContext';

const OfertaBanner = () => {
    const navigate = useNavigate()
    const country = process.env.REACT_APP_COUNTRY;
    const { colorTheme } = useContext(globalContext);
    const [containerVisible, setContainerVisible] = useState(false);
    const [titleVisible, setTitleVisible] = useState(false);
    const [cardsVisible, setCardsVisible] = useState([false, false, false]);
    const [buttonsVisible, setButtonsVisible] = useState(false);

    // Referencias para el Intersection Observer
    const containerRef = useRef(null);
    const titleRef = useRef(null);
    const stepRefs = useRef([]);
    const buttonsRef = useRef(null);

    const [t] = useTranslation("global")

    useEffect(() => {
        // Configuración del Intersection Observer
        const observerOptions = {
            root: null,
            rootMargin: '-5% 0px -5% 0px', // Activa cuando el elemento está 5% dentro del viewport
            threshold: 0.1
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const element = entry.target;
                    
                    // Contenedor principal (efecto fade-in general)
                    if (element === containerRef.current) {
                        setTimeout(() => setContainerVisible(true), 100);
                        // Después del fade-in del contenedor, iniciar animaciones internas
                        setTimeout(() => setTitleVisible(true), 300);
                        setTimeout(() => {
                            setCardsVisible([true, false, false]);
                            setTimeout(() => setCardsVisible([true, true, false]), 200);
                            setTimeout(() => setCardsVisible([true, true, true]), 400);
                        }, 500);
                        setTimeout(() => setButtonsVisible(true), 900);
                    }
                }
            });
        }, observerOptions);

        // Observar solo el contenedor principal
        if (containerRef.current) observer.observe(containerRef.current);

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div 
            ref={containerRef}
            className={`oferta-banner-container ${containerVisible ? 'visible' : ''}`}
        >
            <div className="oferta-content">
                {/* Título principal */}
                <h2 
                    ref={titleRef}
                    className={`oferta-title ${titleVisible ? 'visible' : ''}`} 
                    style={{
                        color: colorTheme === 'dark' ? '#ffffff' : '#515151'
                    }}
                >
                    {t("ofertaBanner.titulo-oferta")}
                </h2>

                {/* Contenedor de pasos horizontales */}
                <div className="process-flow">
                    <div className={`step-number ${cardsVisible[0] ? 'visible' : ''}`}>
                        <div className="number-circle">1</div>
                        <div className="step-details">
                            <div className="step-icon">
                                <IoPersonAddSharp />
                            </div>
                            <p className="step-description">
                                {t("ofertaBanner.primer-paso1")} <br /> 
                                {t("ofertaBanner.primer-paso2")}
                            </p>
                        </div>
                    </div>

                    <div className={`flow-arrow ${cardsVisible[1] ? 'visible' : ''}`}>→</div>

                    <div className={`step-number ${cardsVisible[1] ? 'visible' : ''}`}>
                        <div className="number-circle">2</div>
                        <div className="step-details">
                            <div className="step-icon">
                                <GiClick />
                            </div>
                            <p className="step-description">
                                {t("ofertaBanner.segundo-paso1")}<br /> 
                                {t("ofertaBanner.segundo-paso2")}
                            </p>
                        </div>
                    </div>

                    <div className={`flow-arrow ${cardsVisible[2] ? 'visible' : ''}`}>→</div>

                    <div className={`step-number ${cardsVisible[2] ? 'visible' : ''}`}>
                        <div className="number-circle">3</div>
                        <div className="step-details">
                            <div className="step-icon">
                                <FaCheck />
                            </div>
                            <p className="step-description">
                                {country === "CL"
                                    ? t("ofertaBanner.tercer-paso-chile")
                                    : t("ofertaBanner.tercer-paso")}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Botones de acción */}
                <div className={`action-buttons ${buttonsVisible ? 'visible' : ''}`}>
                    <button className="web-cat-button primary" onClick={() => navigate('/contacto')}>
                        {t("ofertaBanner.boton1")}
                    </button>
                    <button className="web-cat-button secondary" onClick={() => navigate('/registrousuario')}>
                        {t("ofertaBanner.boton2")}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default OfertaBanner
